import React, {Component} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

function mapStateToProps(state) {
   return {}
}

function mapDispatchToProps(dispatch) {
  return {}
}

class StyleGuide extends Component {

  render() {
    return (
      <div className="Home">
        <div className="StyleGuide__section">
          <h1>StyleGuide</h1>
          <h1>H1: The quick brown fox jumps over the lazy dog</h1>
          <h2>H2: The quick brown fox jumps over the lazy dog</h2>
          <h3>H3: The quick brown fox jumps over the lazy dog</h3>
          <h4>H4: The quick brown fox jumps over the lazy dog</h4>
          <p>P: Venmo hexagon cronut prism taiyaki. Vape VHS jianbing, blue bottle aesthetic gochujang hashtag edison bulb DIY cloud bread sartorial venmo small batch. Stumptown narwhal street art coloring book kitsch jean shorts pok pok chia taxidermy. Polaroid salvia meggings pop-up, offal pork belly chicharrones selfies wolf drinking vinegar before they sold out four dollar toast craft beer put a bird on it. Green juice shoreditch lumbersexual gentrify.</p>
          <p className="legal-text">Legal Text: Semiotics pop-up unicorn, art party franzen actually glossier brooklyn tattooed celiac tilde tumblr pug subway tile dreamcatcher. Glossier venmo waistcoat everyday carry gentrify, pitchfork mlkshk tbh asymmetrical kickstarter pop-up air plant. Letterpress gastropub crucifix raclette woke tacos sartorial literally hell of echo park affogato sriracha. Shaman forage occupy, activated charcoal pork belly retro jianbing af umami cred disrupt food truck cold-pressed vaporware dreamcatcher. Crucifix gentrify chambray tofu. Hexagon ennui palo santo semiotics, williamsburg PBR&B knausgaard.</p>
          <a href="">Link: The quick brown fox jumps over the lazy dog</a>
        </div>

        <div className="StyleGuide__section">
          <div className="formRow">
            <label>Sample Form Input:</label>
            <input type="text" placeholder="Give me all your information"></input>
          </div>
          <div className="StyleGuide__buttons">
            <button className="btn">Base Button</button>
            <button className="btn btn--primary">Primary Button</button>
            <button className="btn btn--secondary">Secondary Button</button>
            <button className="btn btn--outline">Outline Button</button>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StyleGuide);



// WEBPACK FOOTER //
// ./src/views/StyleGuide/StyleGuide.js